webpackJsonp([9],{

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookExerciseSelect_vue__ = __webpack_require__(1195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08380eb2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookExerciseSelect_vue__ = __webpack_require__(1364);
function injectStyle (ssrContext) {
  __webpack_require__(1362)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08380eb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookExerciseSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08380eb2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookExerciseSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookExerciseWrite_vue__ = __webpack_require__(1196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cb09c6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookExerciseWrite_vue__ = __webpack_require__(1367);
function injectStyle (ssrContext) {
  __webpack_require__(1365)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42cb09c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookExerciseWrite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cb09c6_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookExerciseWrite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookExerciseComplete_vue__ = __webpack_require__(1197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b06020_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookExerciseComplete_vue__ = __webpack_require__(1370);
function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3b06020"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookExerciseComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b06020_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookExerciseComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookImage_vue__ = __webpack_require__(1198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06855854_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookImage_vue__ = __webpack_require__(1373);
function injectStyle (ssrContext) {
  __webpack_require__(1371)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06855854"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06855854_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VirtualBookViewer__ = __webpack_require__(1356);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    book: 'virtualBook/getBook',
    hasBook: 'virtualBook/hasBook',
    pages: 'virtualBook/getPages'
  })),
  components: {
    VBViewer: __WEBPACK_IMPORTED_MODULE_6__components_VirtualBookViewer__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])({
    setShowLoader: 'setShowLoader',
    setFinished: 'speakup/setFinished'
  }), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    getBook: 'virtualBook/getBook'
  }), {
    answerQuestion: function answerQuestion(payload) {
      this.$store.dispatch('virtualBook/answerQuestion', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        book_id: this.$route.params.book
      }, payload));
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.setShowLoader(true);

              _context.next = 4;
              return _this.getBook(_this.$route.params.book);

            case 4:
              if (_this.hasBook) {
                _context.next = 8;
                break;
              }

              _this.setShowLoader(false);
              _this.$router.replace('/virtual-books');
              return _context.abrupt('return');

            case 8:

              _this.setShowLoader(false);
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);
              _this.setShowLoader(false);
              _this.$router.replace('/virtual-books');

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 11]]);
    }))();
  }
});

/***/ }),

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualBookContainer__ = __webpack_require__(1359);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VBViewer',
  props: {
    pages: {
      required: true
    },
    goBack: {
      type: Function
    },
    edit: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  },
  data: function data() {
    return {
      pageIndex: 0,
      pageNumber: 0,
      minPage: 0,
      maxPage: 0,
      currentHeight: 0,
      maxHeight: 0,
      minHeight: 0
    };
  },

  computed: {
    currentPage: function currentPage() {
      if (!this.pages || !this.pages.length || !this.pages[this.pageIndex]) return {
        page: this.pageNumber,
        type: 'container',
        components: []
      };

      return this.pages[this.pageIndex];
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__VirtualBookContainer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VirtualBookContainer__["a" /* default */]),
  methods: {
    setPagesData: function setPagesData() {
      if (!this.pages.length) {
        this.pageIndex = 0;
        this.$refs['page_number'].value = 0;
        this.pageNumber = 0;
        this.minPage = 0;
        this.maxPage = 0;
        return;
      }

      this.pageNumber = this.pages[this.pageIndex].page;
      this.minPage = this.pages[0].page;
      this.maxPage = this.pages[this.pages.length - 1].page;

      this.$refs['page_number'].value = this.pages[0].page;
    },
    nextPage: function nextPage() {
      if (this.pageIndex < this.pages.length - 1) ++this.pageIndex;
    },
    prevPage: function prevPage() {
      if (this.pageIndex > 0) --this.pageIndex;
    },
    getPage: function getPage(page) {
      if (page > this.maxPage) page = this.maxPage;else if (page < this.minPage) page = this.minPage;

      var pageIndex = !this.pages.length ? 0 : this.pages.findIndex(function (p) {
        return p.page == page;
      });

      if (pageIndex < 0) pageIndex = this.getPage(page + 1);

      return pageIndex;
    },
    goToPage: function goToPage() {
      var pageIndex = this.getPage(this.$refs['page_number'].valueAsNumber);

      this.pageIndex = pageIndex;
      this.pageNumber = this.currentPage.page;

      this.$refs['page_number'].value = this.pageNumber;
    },
    setHeightPage: function setHeightPage() {
      this.maxHeight = this.$refs['page'].$el.scrollHeight - this.$refs['page'].$el.offsetHeight;
      this.minHeight = 0;

      this.currentHeight = this.minHeight;

      this.scrollPage();
    },
    scroll: function scroll(event) {
      this.currentHeight = event.target.scrollTop;
    },
    scrollUp: function scrollUp() {
      this.currentHeight -= 100;

      if (this.currentHeight < this.minHeight) this.currentHeight = this.minHeight;

      this.scrollPage();
    },
    scrollDown: function scrollDown() {
      this.currentHeight += 100;

      if (this.currentHeight > this.maxHeight) this.currentHeight = this.maxHeight;

      this.scrollPage();
    },
    scrollPage: function scrollPage() {
      this.$refs['page'].$el.scrollTop = this.currentHeight;
    }
  },
  watch: {
    pages: function pages() {
      this.setPagesData();
    },
    pageIndex: function pageIndex(val, oldVal) {
      if (val == oldVal) return;

      this.pageNumber = this.currentPage.page;

      this.$refs['page_number'].value = this.pageNumber;

      this.$emit('change');
    },
    currentPage: function currentPage() {
      var _this = this;

      this.$nextTick(function () {
        _this.setHeightPage();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.setPagesData();

    this.$nextTick(function () {
      _this2.setHeightPage();
    });
  }
});

/***/ }),

/***/ 1194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VirtualBookAudio__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VirtualBookDiv__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VirtualBookText__ = __webpack_require__(1385);


var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-container',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__VirtualBookAudio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__VirtualBookAudio__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__VirtualBookDiv__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__VirtualBookDiv__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7__VirtualBookText__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__VirtualBookText__["a" /* default */]), _components),
  props: {
    components: {
      required: true
    },
    data: {
      required: true
    },
    path: {
      required: true
    },
    selectedPath: {
      type: String
    }
  }
});

/***/ }),

/***/ 1195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-exercise-select',
  props: {
    data: {
      required: true
    },
    path: {
      required: true
    },
    draggable: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  },
  data: function data() {
    return {
      answers: [],
      alphabet: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    };
  },

  methods: {
    selectAnswer: function selectAnswer(index) {
      if (this.data.example) return;

      this.answers = this.answers.map(function (a, i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a, { selected: i == index });
      });

      this.$emit('answer', {
        prop: 'answers',
        value: this.answers,
        path: this.path
      });
    }
  },
  watch: {
    data: function data() {
      this.answers = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.data.answers || []);
    }
  },
  beforeMount: function beforeMount() {
    this.answers = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.data.answers || []);
  }
});

/***/ }),

/***/ 1196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-exercise-write',
  props: {
    data: {
      required: true
    },
    path: {
      required: true
    },
    draggable: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  },
  data: function data() {
    return {
      answer: '',
      timeout: null
    };
  },

  methods: {
    answerQuestion: function answerQuestion() {
      var _this = this;

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(function () {
        _this.$emit('answer', {
          prop: 'answer',
          value: _this.answer,
          path: _this.path
        });

        _this.timeout = null;
      }, 1500);
    }
  },
  watch: {
    data: function data() {
      this.answer = this.data.answer;
    }
  },
  beforeMount: function beforeMount() {
    this.answer = this.data.answer;
  }
});

/***/ }),

/***/ 1197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-exercise-complete',
  props: {
    data: {
      required: true
    },
    path: {
      required: true
    },
    draggable: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  },
  data: function data() {
    return {
      words: [],
      timeout: null
    };
  },

  methods: {
    mountWords: function mountWords(question) {
      if (!question) return [];

      var wordsToReplace = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(question.matchAll(/\#(.*?)\#/g)));

      if (!wordsToReplace.length) return [question];

      var words = [];

      var maxIndex = question.length;

      var lastIndex = 0;

      for (var i in wordsToReplace) {
        var match = wordsToReplace[i],
            original = match[0],
            text = match[1],
            index = match.index;

        if (lastIndex != index) {
          words.push({
            type: 'text',
            value: question.slice(lastIndex, index)
          });

          lastIndex = index;
        }

        words.push({
          type: 'input',
          size: text.length * (!this.data.example ? 14 : 8) + 10,
          maxLength: text.length,
          value: !this.data.example ? '' : text
        });

        lastIndex = index + original.length;

        if (i == wordsToReplace.length - 1) {
          if (lastIndex < maxIndex) {
            words.push({
              type: 'text',
              value: question.slice(lastIndex, maxIndex)
            });
          }
        }
      }

      return words;
    },
    answerQuestion: function answerQuestion() {
      var _this = this;

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(function () {
        _this.$emit('answer', {
          prop: 'words',
          value: _this.words,
          path: _this.path
        });

        _this.timeout = null;
      }, 1500);
    }
  },
  watch: {
    data: function data() {
      this.words = !this.data.words ? this.mountWords(this.data.question) : Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.data.words);
    }
  },
  beforeMount: function beforeMount() {
    this.words = !this.data.words ? this.mountWords(this.data.question) : Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["cloneDeep"])(this.data.words);
  }
});

/***/ }),

/***/ 1198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-img',
  props: {
    data: {
      required: true
    },
    path: {
      required: true
    },
    draggable: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  }
});

/***/ }),

/***/ 1199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookAudio_vue__ = __webpack_require__(1200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef631ab_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookAudio_vue__ = __webpack_require__(1376);
function injectStyle (ssrContext) {
  __webpack_require__(1374)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ef631ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef631ab_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-audio',
  props: {
    data: {
      required: true
    },
    path: {
      required: true
    },
    draggable: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  },
  data: function data() {
    return {
      canplay: false,
      playing: false,
      duration: 0,
      currentTime: 0
    };
  },

  methods: {
    setAudioData: function setAudioData(event) {
      this.canplay = true;
      this.playing = false;
      this.duration = event.target.duration;
      this.currentTime = event.target.currentTime;
    },
    toogle: function toogle() {
      if (this.data.src && this.canplay) {
        if (this.$refs['vb-audio-player'].paused) this.$refs['vb-audio-player'].play();else this.$refs['vb-audio-player'].pause();
      }
    }
  }
});

/***/ }),

/***/ 1201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VirtualBookAudio__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VirtualBookDivVertical__ = __webpack_require__(1380);


var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-div',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5__VirtualBookAudio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__VirtualBookAudio__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6__VirtualBookDivVertical__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__VirtualBookDivVertical__["a" /* default */]), _components),
  props: {
    components: {
      required: true
    },
    data: {
      required: true
    },
    path: {
      required: true
    },
    selectedPath: {
      type: String
    }
  }
});

/***/ }),

/***/ 1202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__ = __webpack_require__(1127);


var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-div-vertical',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VirtualBookExerciseSelect__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VirtualBookExerciseWrite__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VirtualBookExerciseComplete__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VirtualBookImage__["a" /* default */]), _components),
  props: {
    components: {
      required: true
    },
    data: {
      required: true
    },
    path: {
      required: true
    },
    selectedPath: {
      type: String
    }
  }
});

/***/ }),

/***/ 1203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vb-text',
  props: {
    data: {
      required: true
    },
    path: {
      required: true
    },
    draggable: {
      type: Boolean
    },
    selectedPath: {
      type: String
    }
  }
});

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1355);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("ead0a294", content, true, {});

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".align-center{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@-webkit-keyframes loadAudioPlayer{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@keyframes loadAudioPlayer{0%{stroke-dasharray:0,100}to{stroke-dasharray:100,100}}@-webkit-keyframes loadAudioPlayerReset{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}@keyframes loadAudioPlayerReset{0%{stroke-dasharray:100,100}to{stroke-dasharray:0,100}}.animationLoadCircle{-webkit-animation-name:loadAudioPlayer;animation-name:loadAudioPlayer;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.animationLoadCircle.reset{animation-direction:reverse;-webkit-animation-duration:.5s;animation-duration:.5s}.unit-challenge__video{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;background:#d5d5d5;height:350px;border-radius:12px;position:relative;overflow:hidden}@media (max-width:440px){.unit-challenge__video{height:160px;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}}.unit-challenge__video .play{position:absolute;top:0;left:0;z-index:100;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.unit-challenge__video .play_btn{-webkit-box-shadow:0 0 0 10px hsla(0,0%,100%,.3);box-shadow:0 0 0 10px hsla(0,0%,100%,.3);border-radius:50%;-webkit-transition:.3s;transition:.3s;cursor:pointer}.unit-challenge__video .play_btn:hover{-webkit-box-shadow:0 0 0 20px hsla(0,0%,100%,.3);box-shadow:0 0 0 20px hsla(0,0%,100%,.3)}.unit-challenge__video--image{-o-object-fit:cover;object-fit:cover;height:420px}.unit-challenge__video--video{-o-object-fit:cover;object-fit:cover;width:100%;height:auto}.unit-challenge__questions{-webkit-box-sizing:border-box;box-sizing:border-box;height:350px;overflow-y:auto;margin-left:20px;padding-right:20px}.unit-challenge__block{width:100%;height:100%;background:rgba(0,0,0,.8);position:absolute;top:0;left:0;z-index:999}.unit-challenge__block__center{color:#fff;width:90%;max-width:900px}.unit-challenge__block__center .icon-img{margin:20px}.unit-challenge__block__center .btn{margin:15px}@media (max-width:820px){.unit-challenge{-ms-flex-wrap:wrap;flex-wrap:wrap}.unit-challenge__questions{margin-left:0;padding-right:0;margin-top:20px;height:auto}.unit-challenge__block{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-top:100px}.unit-challenge__block__center{-ms-flex-wrap:wrap;flex-wrap:wrap}}@media (max-width:440px){.mobileWrap{-ms-flex-wrap:wrap;flex-wrap:wrap}}@media (max-width:440px){.mobileAdjust,.mobileWrap{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.mobileAdjust{width:100%;margin:5px}}.life-box{width:75px}@media (max-width:440px){.life-box{width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:5px}}.life-box .life-item{margin-left:5px}.life-box .life-item:first-child{margin-left:10px}.used{-webkit-filter:grayscale(.75);filter:grayscale(.75)}.btn-transition-enter-active,.btn-transition-leave-active{-webkit-transition:opacity .2s;transition:opacity .2s}.btn-transition-enter,.btn-transition-leave-to{opacity:0}.container--unit{padding:7px 13px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:25px;position:relative}.container--unit .container--unit__box{background:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.08),0 6px 7px 0 rgba(0,0,0,.04);box-shadow:0 2px 4px 0 rgba(0,0,0,.08),0 6px 7px 0 rgba(0,0,0,.04);border-radius:20px;-webkit-box-sizing:border-box;box-sizing:border-box;border:2px solid #525252;text-align:center;-webkit-transition:.3s;transition:.3s;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.container--unit .container--unit__box:hover{-webkit-transform:scale(1.06);transform:scale(1.06);background:#dfdfdf;-webkit-box-shadow:5px 5px 5px 1px rgba(0,0,0,.2);box-shadow:5px 5px 5px 1px rgba(0,0,0,.2)}.container--unit .container--unit__box .container--unit__title{font-size:14px;text-align:center;color:#717171}.container--unit .container--unit__box .container--unit__btn{margin:5px 0 10px}.container--unit .container--unit__box .container--unit__ball{width:105px;height:55px;margin-top:-20px;border-radius:15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;text-align:center}.container--unit .container--unit__box .container--unit__ball span{font-size:15px;font-weight:300}.container--unit .container--unit__box .container--unit__ball h3{font-size:40px;margin-left:5px;font-weight:400}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/pages/virtualBooks/book.vue"],"names":[],"mappings":"AACA,cACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,mCACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,2BACA,GACI,sBAAyB,CAC5B,AACD,GACI,wBAA2B,CAC9B,CACA,AACD,wCACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,gCACA,GACI,wBAA2B,CAC9B,AACD,GACI,sBAAyB,CAC5B,CACA,AACD,qBACE,uCAAwC,AAChC,+BAAgC,AACxC,qCAAsC,AAC9B,4BAA8B,CACvC,AACD,2BACI,4BAA6B,AAC7B,+BAAgC,AACxB,sBAAwB,CACnC,AACD,uBACE,8BAA+B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,mBAAoB,AACpB,aAAc,AACd,mBAAoB,AACpB,kBAAmB,AACnB,eAAiB,CAClB,AACD,yBACA,uBACM,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,oBAAsB,CACnC,CACA,AACD,6BACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,iCACI,iDAAwD,AAChD,yCAAgD,AACxD,kBAAmB,AACnB,uBAAyB,AACzB,eAAiB,AACjB,cAAgB,CACnB,AACD,uCACM,iDAAwD,AAChD,wCAAgD,CAC7D,AACD,8BACE,oBAAqB,AAClB,iBAAkB,AACrB,YAAc,CACf,AACD,8BACE,oBAAqB,AAClB,iBAAkB,AACrB,WAAY,AACZ,WAAa,CACd,AACD,2BACE,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,gBAAiB,AACjB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,uBACE,WAAY,AACZ,YAAa,AACb,0BAA+B,AAC/B,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAa,CACd,AACD,+BACE,WAAY,AACZ,UAAW,AACX,eAAiB,CAClB,AACD,yCACI,WAAa,CAChB,AACD,oCACI,WAAa,CAChB,AACD,yBACA,gBACI,mBAAoB,AAChB,cAAgB,CACvB,AACD,2BACI,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,WAAa,CAChB,AACD,uBACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAmB,CACtB,AACD,+BACI,mBAAoB,AAChB,cAAgB,CACvB,CACA,AACD,yBACA,YACI,mBAAoB,AAChB,cAAgB,CAIvB,CACA,AACD,yBACA,0BANI,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAUnC,AAND,cACI,WAAY,AAIZ,UAAY,CACf,CACA,AACD,UACE,UAAY,CACb,AACD,yBACA,UACM,WAAY,AACZ,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,UAAY,CACjB,CACA,AACD,qBACI,eAAiB,CACpB,AACD,iCACM,gBAAkB,CACvB,AACD,MACE,8BAAgC,AACxB,qBAAwB,CACjC,AACD,0DACE,+BAAgC,AAChC,sBAAwB,CACzB,AACD,+CACE,SAAW,CACZ,AACD,iBACE,iBAAkB,AAClB,8BAA+B,AACvB,sBAAuB,AAC/B,gBAAiB,AACjB,iBAAmB,CACpB,AACD,uCACI,gBAAoB,AACpB,2EAAqF,AAC7E,mEAA6E,AACrF,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,yBAA0B,AAC1B,kBAAmB,AACnB,uBAAyB,AACzB,eAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACnB,AACD,6CACM,8BAA+B,AACvB,sBAAuB,AAC/B,mBAAoB,AACpB,kDAAuD,AAC/C,yCAA+C,CAC5D,AACD,+DACM,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CACpB,AACD,6DACM,iBAAyB,CAC9B,AACD,8DACM,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,iBAAmB,CACxB,AACD,mEACQ,eAAgB,AAChB,eAAiB,CACxB,AACD,iEACQ,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACxB","file":"book.vue","sourcesContent":["\n.align-center {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@-webkit-keyframes loadAudioPlayer {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@keyframes loadAudioPlayer {\nfrom {\n    stroke-dasharray: 0, 100;\n}\nto {\n    stroke-dasharray: 100, 100;\n}\n}\n@-webkit-keyframes loadAudioPlayerReset {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n@keyframes loadAudioPlayerReset {\nfrom {\n    stroke-dasharray: 100, 100;\n}\nto {\n    stroke-dasharray: 0, 100;\n}\n}\n.animationLoadCircle {\n  -webkit-animation-name: loadAudioPlayer;\n          animation-name: loadAudioPlayer;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n}\n.animationLoadCircle.reset {\n    animation-direction: reverse;\n    -webkit-animation-duration: .5s;\n            animation-duration: .5s;\n}\n.unit-challenge__video {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  background: #D5D5D5;\n  height: 350px;\n  border-radius: 12px;\n  position: relative;\n  overflow: hidden;\n}\n@media (max-width: 440px) {\n.unit-challenge__video {\n      height: 160px;\n      -webkit-box-align: baseline;\n          -ms-flex-align: baseline;\n              align-items: baseline;\n}\n}\n.unit-challenge__video .play {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.unit-challenge__video .play_btn {\n    -webkit-box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.3);\n            box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    cursor: pointer;\n}\n.unit-challenge__video .play_btn:hover {\n      -webkit-box-shadow: 0 0 0 20px rgba(255, 255, 255, 0.3);\n              box-shadow: 0 0 0 20px rgba(255, 255, 255, 0.3);\n}\n.unit-challenge__video--image {\n  -o-object-fit: cover;\n     object-fit: cover;\n  height: 420px;\n}\n.unit-challenge__video--video {\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 100%;\n  height: auto;\n}\n.unit-challenge__questions {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 350px;\n  overflow-y: auto;\n  margin-left: 20px;\n  padding-right: 20px;\n}\n.unit-challenge__block {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}\n.unit-challenge__block__center {\n  color: #fff;\n  width: 90%;\n  max-width: 900px;\n}\n.unit-challenge__block__center .icon-img {\n    margin: 20px;\n}\n.unit-challenge__block__center .btn {\n    margin: 15px;\n}\n@media (max-width: 820px) {\n.unit-challenge {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.unit-challenge__questions {\n    margin-left: 0;\n    padding-right: 0;\n    margin-top: 20px;\n    height: auto;\n}\n.unit-challenge__block {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    padding-top: 100px;\n}\n.unit-challenge__block__center {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n}\n@media (max-width: 440px) {\n.mobileWrap {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n}\n@media (max-width: 440px) {\n.mobileAdjust {\n    width: 100%;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 5px;\n}\n}\n.life-box {\n  width: 75px;\n}\n@media (max-width: 440px) {\n.life-box {\n      width: 100%;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      margin: 5px;\n}\n}\n.life-box .life-item {\n    margin-left: 5px;\n}\n.life-box .life-item:first-child {\n      margin-left: 10px;\n}\n.used {\n  -webkit-filter: grayscale(0.75);\n          filter: grayscale(0.75);\n}\n.btn-transition-enter-active, .btn-transition-leave-active {\n  -webkit-transition: opacity .2s;\n  transition: opacity .2s;\n}\n.btn-transition-enter, .btn-transition-leave-to {\n  opacity: 0;\n}\n.container--unit {\n  padding: 7px 13px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-top: 25px;\n  position: relative;\n}\n.container--unit .container--unit__box {\n    background: #FFFFFF;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 6px 7px 0 rgba(0, 0, 0, 0.04);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 6px 7px 0 rgba(0, 0, 0, 0.04);\n    border-radius: 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 2px solid #525252;\n    text-align: center;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n}\n.container--unit .container--unit__box:hover {\n      -webkit-transform: scale(1.06);\n              transform: scale(1.06);\n      background: #dfdfdf;\n      -webkit-box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);\n              box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);\n}\n.container--unit .container--unit__box .container--unit__title {\n      font-size: 14px;\n      text-align: center;\n      color: #717171;\n}\n.container--unit .container--unit__box .container--unit__btn {\n      margin: 5px 0px 10px 0px;\n}\n.container--unit .container--unit__box .container--unit__ball {\n      width: 105px;\n      height: 55px;\n      margin-top: -20px;\n      border-radius: 15px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      color: #fff;\n      text-align: center;\n}\n.container--unit .container--unit__box .container--unit__ball span {\n        font-size: 15px;\n        font-weight: 300;\n}\n.container--unit .container--unit__box .container--unit__ball h3 {\n        font-size: 40px;\n        margin-left: 5px;\n        font-weight: 400;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358bf51c_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1390);
function injectStyle (ssrContext) {
  __webpack_require__(1357)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-358bf51c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358bf51c_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("0e992608", content, true, {});

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-viewer[data-v-358bf51c]{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;max-width:1050px;padding:20px}.vb-page[data-v-358bf51c]{overflow-y:auto;max-height:540px}.vb-control[data-v-358bf51c]{border:1px solid #9ebbda;border-radius:30px;background:#cce3fb;padding:1.5rem;margin:0 0 0 .5rem}.vb-control .vb-control-div[data-v-358bf51c],.vb-control[data-v-358bf51c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.vb-control .vb-control-div[data-v-358bf51c]{width:100%}.vb-control .vb-control-div[data-v-358bf51c]:not(:last-child){padding-bottom:1rem}.vb-control .vb-control-div>.vb-control-btn[data-v-358bf51c]:last-child{margin-top:1rem}.vb-control button.vb-control-btn[data-v-358bf51c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;line-height:30px;width:190px;font-size:12px;background:#98b2ce;border:1px solid #a1b9d3;border-radius:25px;padding:10px;color:#416182;font-weight:300;font-family:volte,Arial,Helvetica,sans-serif}.vb-control button.vb-control-btn.vb-control-btn-back[data-v-358bf51c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fff;color:#416182;margin-top:4rem!important}.vb-control button.vb-control-btn .vb-control-btn-icon[data-v-358bf51c]{margin-right:1.5rem;background:#fff;color:#98b2ce;padding:0 10px;border-radius:25px}.vb-control button.vb-control-btn[data-v-358bf51c]:disabled{background:#b4c7dc;color:#89a4c2}.vb-control button.vb-control-btn:disabled .vb-control-btn-icon[data-v-358bf51c]{background:#89a4c2;color:#b4c7dc}.vb-control .vb-control-page[data-v-358bf51c]{display:-webkit-box;display:-ms-flexbox;display:flex;width:190px;font-size:12px;border:1px solid #a1b9d3;border-radius:25px;background:#fff}.vb-control .vb-control-page button.vb-control-page-btn[data-v-358bf51c]{padding:10px 20px;border-radius:25px;background:#98b2ce;border:0;border-right:1px solid #a1b9d3;color:#446384;font-weight:300;font-size:20px;font-family:volte,Arial,Helvetica,sans-serif}.vb-control .vb-control-page input.vb-control-page-input[data-v-358bf51c]{font-family:volte,Arial,Helvetica,sans-serif;font-weight:700;font-size:24px;color:#98b2ce;text-align:center;border-radius:25px;width:92px;border:0;padding-right:1rem}.vb-control .vb-control-page input.vb-control-page-input[data-v-358bf51c]:focus{outline:none}@media (max-width:768px){.vb-viewer[data-v-358bf51c]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.vb-control[data-v-358bf51c]{margin:0 0 20px}.vb-control .vb-control-div[data-v-358bf51c]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.vb-control .vb-control-div[data-v-358bf51c]:last-of-type{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.vb-control .vb-control-div>.vb-control-btn[data-v-358bf51c]:last-child{margin-top:0}.vb-control .vb-control-div>.vb-control-page[data-v-358bf51c]{-webkit-box-flex:1;-ms-flex:1;flex:1}}@media (max-width:560px){.vb-control-div.vb-controll-div--hide[data-v-358bf51c]{display:none;padding-bottom:0}.vb-control-div .vb-control-btn[data-v-358bf51c]{width:auto!important}.vb-control-div .vb-control-btn-icon[data-v-358bf51c]{margin:0!important}.vb-control-div .vb-control-btn-text[data-v-358bf51c]{display:none}.vb-control-div[data-v-358bf51c]:last-of-type{padding-bottom:0!important}.vb-control-btn-back[data-v-358bf51c]{display:none!important}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/index.vue"],"names":[],"mappings":"AACA,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,YAAc,CACf,AACD,0BACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,6BACE,yBAA0B,AAC1B,mBAAoB,AACpB,mBAAoB,AAQpB,eAAgB,AAChB,kBAAoB,CACrB,AACD,0EAVE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAahC,AATD,6CAQI,UAAY,CACf,AACD,8DACM,mBAAqB,CAC1B,AACD,wEACM,eAAiB,CACtB,AACD,mDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,iBAAkB,AAClB,YAAa,AACb,eAAgB,AAChB,mBAAoB,AACpB,yBAA0B,AAC1B,mBAAoB,AACpB,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,4CAAmD,CACtD,AACD,uEACM,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAoB,AACpB,cAAe,AACf,yBAA4B,CACjC,AACD,wEACM,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,eAAkB,AAClB,kBAAoB,CACzB,AACD,4DACM,mBAAoB,AACpB,aAAe,CACpB,AACD,iFACQ,mBAAoB,AACpB,aAAe,CACtB,AACD,8CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,eAAgB,AAChB,yBAA0B,AAC1B,mBAAoB,AACpB,eAAiB,CACpB,AACD,yEACM,kBAAmB,AACnB,mBAAoB,AACpB,mBAAoB,AACpB,SAAU,AACV,+BAAgC,AAChC,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,4CAAmD,CACxD,AACD,0EACM,6CAAmD,AACnD,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,WAAY,AACZ,SAAU,AACV,kBAAoB,CACzB,AACD,gFACQ,YAAc,CACrB,AACD,yBACA,4BACI,4BAA6B,AAC7B,8BAA+B,AAC3B,kCAAmC,AAC/B,6BAA+B,CAC1C,AACD,6BACI,eAAmB,CACtB,AACD,6CACM,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC5C,AACD,0DACQ,8BAA+B,AAC/B,8BAA+B,AAC3B,+BAAgC,AAC5B,0BAA4B,CAC3C,AACD,wEACQ,YAAc,CACrB,AACD,8DACQ,mBAAoB,AAChB,WAAY,AACR,MAAQ,CACvB,CACA,AACD,yBACA,uDACI,aAAc,AACd,gBAAkB,CACrB,AACD,iDACI,oBAAuB,CAC1B,AACD,sDACM,kBAAqB,CAC1B,AACD,sDACM,YAAc,CACnB,AACD,8CACI,0BAA6B,CAChC,AACD,sCACI,sBAAyB,CAC5B,CACA","file":"index.vue","sourcesContent":["\n.vb-viewer[data-v-358bf51c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  max-width: 1050px;\n  padding: 20px;\n}\n.vb-page[data-v-358bf51c] {\n  overflow-y: auto;\n  max-height: 540px;\n}\n.vb-control[data-v-358bf51c] {\n  border: 1px solid #9ebbda;\n  border-radius: 30px;\n  background: #cce3fb;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 1.5rem;\n  margin: 0 0 0 .5rem;\n}\n.vb-control .vb-control-div[data-v-358bf51c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 100%;\n}\n.vb-control .vb-control-div[data-v-358bf51c]:not(:last-child) {\n      padding-bottom: 1rem;\n}\n.vb-control .vb-control-div > .vb-control-btn[data-v-358bf51c]:last-child {\n      margin-top: 1rem;\n}\n.vb-control button.vb-control-btn[data-v-358bf51c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: left;\n        -ms-flex-pack: left;\n            justify-content: left;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    text-align: center;\n    line-height: 30px;\n    width: 190px;\n    font-size: 12px;\n    background: #98b2ce;\n    border: 1px solid #a1b9d3;\n    border-radius: 25px;\n    padding: 10px;\n    color: #416182;\n    font-weight: 300;\n    font-family: 'volte', Arial, Helvetica, sans-serif;\n}\n.vb-control button.vb-control-btn.vb-control-btn-back[data-v-358bf51c] {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      background: #ffffff;\n      color: #416182;\n      margin-top: 4rem !important;\n}\n.vb-control button.vb-control-btn .vb-control-btn-icon[data-v-358bf51c] {\n      margin-right: 1.5rem;\n      background: #fff;\n      color: #98b2ce;\n      padding: 0px 10px;\n      border-radius: 25px;\n}\n.vb-control button.vb-control-btn[data-v-358bf51c]:disabled {\n      background: #b4c7dc;\n      color: #89a4c2;\n}\n.vb-control button.vb-control-btn:disabled .vb-control-btn-icon[data-v-358bf51c] {\n        background: #89a4c2;\n        color: #b4c7dc;\n}\n.vb-control .vb-control-page[data-v-358bf51c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 190px;\n    font-size: 12px;\n    border: 1px solid #a1b9d3;\n    border-radius: 25px;\n    background: #fff;\n}\n.vb-control .vb-control-page button.vb-control-page-btn[data-v-358bf51c] {\n      padding: 10px 20px;\n      border-radius: 25px;\n      background: #98b2ce;\n      border: 0;\n      border-right: 1px solid #a1b9d3;\n      color: #446384;\n      font-weight: 300;\n      font-size: 20px;\n      font-family: 'volte', Arial, Helvetica, sans-serif;\n}\n.vb-control .vb-control-page input.vb-control-page-input[data-v-358bf51c] {\n      font-family: 'volte', Arial, Helvetica, sans-serif;\n      font-weight: 700;\n      font-size: 24px;\n      color: #98b2ce;\n      text-align: center;\n      border-radius: 25px;\n      width: 92px;\n      border: 0;\n      padding-right: 1rem;\n}\n.vb-control .vb-control-page input.vb-control-page-input[data-v-358bf51c]:focus {\n        outline: none;\n}\n@media (max-width: 768px) {\n.vb-viewer[data-v-358bf51c] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: column-reverse;\n            flex-direction: column-reverse;\n}\n.vb-control[data-v-358bf51c] {\n    margin: 0 0 20px 0;\n}\n.vb-control .vb-control-div[data-v-358bf51c] {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.vb-control .vb-control-div[data-v-358bf51c]:last-of-type {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: reverse;\n            -ms-flex-direction: row-reverse;\n                flex-direction: row-reverse;\n}\n.vb-control .vb-control-div > .vb-control-btn[data-v-358bf51c]:last-child {\n        margin-top: 0;\n}\n.vb-control .vb-control-div > .vb-control-page[data-v-358bf51c] {\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n}\n}\n@media (max-width: 560px) {\n.vb-control-div.vb-controll-div--hide[data-v-358bf51c] {\n    display: none;\n    padding-bottom: 0;\n}\n.vb-control-div .vb-control-btn[data-v-358bf51c] {\n    width: auto !important;\n}\n.vb-control-div .vb-control-btn-icon[data-v-358bf51c] {\n      margin: 0 !important;\n}\n.vb-control-div .vb-control-btn-text[data-v-358bf51c] {\n      display: none;\n}\n.vb-control-div[data-v-358bf51c]:last-of-type {\n    padding-bottom: 0 !important;\n}\n.vb-control-btn-back[data-v-358bf51c] {\n    display: none !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookContainer_vue__ = __webpack_require__(1194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9cf520_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookContainer_vue__ = __webpack_require__(1389);
function injectStyle (ssrContext) {
  __webpack_require__(1360)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a9cf520"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9cf520_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1361);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("190bd1c0", content, true, {});

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-container[data-v-5a9cf520]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.vb-container [data-v-5a9cf520]:not(:first-child){margin-top:10px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookContainer.vue"],"names":[],"mappings":"AACA,+BACE,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACtB,AACD,kDACI,eAAiB,CACpB","file":"VirtualBookContainer.vue","sourcesContent":["\n.vb-container[data-v-5a9cf520] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.vb-container *[data-v-5a9cf520]:not(:first-child) {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("40726001", content, true, {});

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-exercise-select[data-v-08380eb2]{font-size:13px;text-align:left;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.vb-exercise-select-question[data-v-08380eb2]{color:#670000;border:2px solid #fa0;border-radius:10px;font-weight:600;padding:10px 15px}.vb-exercise-select-answers[data-v-08380eb2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.vb-exercise-select-answers-item[data-v-08380eb2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#d8d8d8;color:#818181;margin-top:.5rem;padding:5px 10px 5px 5px;border-radius:25px}.vb-exercise-select-answers-item-dot[data-v-08380eb2]{color:#fff;font-weight:600;text-align:center;background-color:#afafaf;border-radius:25px;width:26px;height:26px;padding:2px 10px;margin-right:5px}.vb-exercise-select-answers-item.selected[data-v-08380eb2]{background-color:#44a9ff;color:#fff;font-weight:600}.vb-exercise-select-answers-item.selected .vb-exercise-select-answers-item-dot[data-v-08380eb2]{background-color:#007af5}.vb-exercise-select.selected[data-v-08380eb2]{border:.2rem dashed red}.vb-exercise-select-empty[data-v-08380eb2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:.5rem;height:2rem;border:.2rem dashed brown}.vb-exercise-select-empty.selected[data-v-08380eb2]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookExerciseSelect.vue"],"names":[],"mappings":"AACA,qCACE,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,8CACI,cAAe,AACf,sBAA0B,AAC1B,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,6CACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,kDACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AAC1B,cAAe,AACf,iBAAkB,AAClB,yBAA0B,AAC1B,kBAAoB,CACzB,AACD,sDACQ,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,yBAA0B,AAC1B,mBAAoB,AACpB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,gBAAkB,CACzB,AACD,2DACQ,yBAA0B,AAC1B,WAAY,AACZ,eAAiB,CACxB,AACD,gGACU,wBAA0B,CACnC,AACD,8CACI,uBAAyB,CAC5B,AACD,2CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,aAAc,AACd,YAAa,AACb,yBAA2B,CAC5B,AACD,oDACI,uBAAyB,CAC5B","file":"VirtualBookExerciseSelect.vue","sourcesContent":["\n.vb-exercise-select[data-v-08380eb2] {\n  font-size: 13px;\n  text-align: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.vb-exercise-select-question[data-v-08380eb2] {\n    color: #670000;\n    border: 2px solid #ffaa00;\n    border-radius: 10px;\n    font-weight: 600;\n    padding: 10px 15px;\n}\n.vb-exercise-select-answers[data-v-08380eb2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.vb-exercise-select-answers-item[data-v-08380eb2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: start;\n          -ms-flex-pack: start;\n              justify-content: flex-start;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      background-color: #d8d8d8;\n      color: #818181;\n      margin-top: .5rem;\n      padding: 5px 10px 5px 5px;\n      border-radius: 25px;\n}\n.vb-exercise-select-answers-item-dot[data-v-08380eb2] {\n        color: #fff;\n        font-weight: 600;\n        text-align: center;\n        background-color: #afafaf;\n        border-radius: 25px;\n        width: 26px;\n        height: 26px;\n        padding: 2px 10px;\n        margin-right: 5px;\n}\n.vb-exercise-select-answers-item.selected[data-v-08380eb2] {\n        background-color: #44a9ff;\n        color: #fff;\n        font-weight: 600;\n}\n.vb-exercise-select-answers-item.selected .vb-exercise-select-answers-item-dot[data-v-08380eb2] {\n          background-color: #007af5;\n}\n.vb-exercise-select.selected[data-v-08380eb2] {\n    border: .2rem dashed red;\n}\n.vb-exercise-select-empty[data-v-08380eb2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin: .5rem;\n  height: 2rem;\n  border: .2rem dashed brown;\n}\n.vb-exercise-select-empty.selected[data-v-08380eb2] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.question || _vm.answers.length)?_c('div',{staticClass:"vb-exercise-select",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_c('div',{staticClass:"vb-exercise-select-question"},[_vm._v("\n    "+_vm._s(_vm.data.question)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"vb-exercise-select-answers"},_vm._l((_vm.answers),function(answer,key){return _c('div',{key:("answer-" + key),staticClass:"vb-exercise-select-answers-item",class:{ selected: answer.selected },on:{"click":function($event){$event.preventDefault();return _vm.selectAnswer(key)}}},[_c('div',{staticClass:"vb-exercise-select-answers-item-dot"},[_vm._v("\n        "+_vm._s(_vm.alphabet[key])+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"vb-exercise-select-answers-item-text"},[_vm._v("\n        "+_vm._s(answer.answer)+"\n      ")])])}),0)]):_c('div',{staticClass:"vb-exercise-select-empty",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_vm._v("\n  Exercise select\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1366);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("5f5f377c", content, true, {});

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-exercise-write[data-v-42cb09c6]{font-size:13px;text-align:left}.vb-exercise-write-question[data-v-42cb09c6]{color:#670000;border:2px solid #fa0;border-radius:10px;font-weight:600;padding:10px 15px}.vb-exercise-write-answer[data-v-42cb09c6]{background-color:#d8d8d8;margin-top:10px;border-radius:10px;padding:5px 10px}.vb-exercise-write-answer.answered[data-v-42cb09c6]{background-color:#efdba4;color:#3e3e3e}.vb-exercise-write-answer textarea[data-v-42cb09c6]{background-color:transparent;border:none;width:100%;height:46px!important;resize:none}.vb-exercise-write-answer textarea[data-v-42cb09c6]:focus{outline:none}.vb-exercise-write.selected[data-v-42cb09c6]{border:.2rem dashed red}.vb-exercise-write-empty[data-v-42cb09c6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:.5rem;height:2rem;border:.2rem dashed brown}.vb-exercise-write-empty.selected[data-v-42cb09c6]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookExerciseWrite.vue"],"names":[],"mappings":"AACA,oCACE,eAAgB,AAChB,eAAiB,CAClB,AACD,6CACI,cAAe,AACf,sBAA0B,AAC1B,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,2CACI,yBAA0B,AAC1B,gBAAiB,AACjB,mBAAoB,AACpB,gBAAkB,CACrB,AACD,oDACM,yBAA0B,AAC1B,aAAe,CACpB,AACD,oDACM,6BAA8B,AAC9B,YAAa,AACb,WAAY,AACZ,sBAAwB,AACxB,WAAa,CAClB,AACD,0DACQ,YAAc,CACrB,AACD,6CACI,uBAAyB,CAC5B,AACD,0CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,aAAc,AACd,YAAa,AACb,yBAA2B,CAC5B,AACD,mDACI,uBAAyB,CAC5B","file":"VirtualBookExerciseWrite.vue","sourcesContent":["\n.vb-exercise-write[data-v-42cb09c6] {\n  font-size: 13px;\n  text-align: left;\n}\n.vb-exercise-write-question[data-v-42cb09c6] {\n    color: #670000;\n    border: 2px solid #ffaa00;\n    border-radius: 10px;\n    font-weight: 600;\n    padding: 10px 15px;\n}\n.vb-exercise-write-answer[data-v-42cb09c6] {\n    background-color: #d8d8d8;\n    margin-top: 10px;\n    border-radius: 10px;\n    padding: 5px 10px;\n}\n.vb-exercise-write-answer.answered[data-v-42cb09c6] {\n      background-color: #efdba4;\n      color: #3e3e3e;\n}\n.vb-exercise-write-answer textarea[data-v-42cb09c6] {\n      background-color: transparent;\n      border: none;\n      width: 100%;\n      height: 46px !important;\n      resize: none;\n}\n.vb-exercise-write-answer textarea[data-v-42cb09c6]:focus {\n        outline: none;\n}\n.vb-exercise-write.selected[data-v-42cb09c6] {\n    border: .2rem dashed red;\n}\n.vb-exercise-write-empty[data-v-42cb09c6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin: .5rem;\n  height: 2rem;\n  border: .2rem dashed brown;\n}\n.vb-exercise-write-empty.selected[data-v-42cb09c6] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.question)?_c('div',{staticClass:"vb-exercise-write",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_c('div',{staticClass:"vb-exercise-write-question"},[_vm._v("\n    "+_vm._s(_vm.data.question)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"vb-exercise-write-answer",class:{ answered: !!_vm.answer }},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"readonly":!!_vm.data.example},domProps:{"value":(_vm.answer)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.answer=$event.target.value},_vm.answerQuestion]}})])]):_c('div',{staticClass:"vb-exercise-write-empty",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_vm._v("\n  Exercise write\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1369);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("3dfc99c2", content, true, {});

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-complete[data-v-f3b06020]{font-size:13px;text-align:left}.vb-complete-question[data-v-f3b06020]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#670000;border:2px solid #fa0;border-radius:10px;font-weight:600;padding:10px 15px}.vb-complete-question-field[data-v-f3b06020]{margin:2px 5px}.vb-complete-question-field input[data-v-f3b06020]{border:none;border-bottom:2px solid #000;padding:0 5px;text-align:center}.vb-complete-question-field input[data-v-f3b06020]:focus{outline:none}.vb-complete.selected[data-v-f3b06020]{border:.2rem dashed red}.vb-complete-empty[data-v-f3b06020]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:.5rem;height:2rem;border:.2rem dashed brown}.vb-complete-empty.selected[data-v-f3b06020]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookExerciseComplete.vue"],"names":[],"mappings":"AACA,8BACE,eAAgB,AAChB,eAAiB,CAClB,AACD,uCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAe,AACf,sBAA0B,AAC1B,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,6CACM,cAAgB,CACrB,AACD,mDACQ,YAAa,AACb,6BAA8B,AAC9B,cAAe,AACf,iBAAmB,CAC1B,AACD,yDACU,YAAc,CACvB,AACD,uCACI,uBAAyB,CAC5B,AACD,oCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,aAAc,AACd,YAAa,AACb,yBAA2B,CAC5B,AACD,6CACI,uBAAyB,CAC5B","file":"VirtualBookExerciseComplete.vue","sourcesContent":["\n.vb-complete[data-v-f3b06020] {\n  font-size: 13px;\n  text-align: left;\n}\n.vb-complete-question[data-v-f3b06020] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #670000;\n    border: 2px solid #ffaa00;\n    border-radius: 10px;\n    font-weight: 600;\n    padding: 10px 15px;\n}\n.vb-complete-question-field[data-v-f3b06020] {\n      margin: 2px 5px;\n}\n.vb-complete-question-field input[data-v-f3b06020] {\n        border: none;\n        border-bottom: 2px solid #000;\n        padding: 0 5px;\n        text-align: center;\n}\n.vb-complete-question-field input[data-v-f3b06020]:focus {\n          outline: none;\n}\n.vb-complete.selected[data-v-f3b06020] {\n    border: .2rem dashed red;\n}\n.vb-complete-empty[data-v-f3b06020] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin: .5rem;\n  height: 2rem;\n  border: .2rem dashed brown;\n}\n.vb-complete-empty.selected[data-v-f3b06020] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.question)?_c('div',{staticClass:"vb-complete",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_c('div',{staticClass:"vb-complete-question"},[_vm._l((_vm.words),function(word,index){return _c('div',{key:("vb-word-" + index),staticClass:"vb-complete-question-field"},[(word.type == 'text')?_c('span',[_vm._v("\n        "+_vm._s(word.value)+"\n      ")]):(word.type == 'input')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(word.value),expression:"word.value"}],style:({ width: ((word.size) + "px") }),attrs:{"type":"text","readonly":!!_vm.data.example},domProps:{"value":(word.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(word, "value", $event.target.value)},_vm.answerQuestion]}}):_vm._e()])}),_vm._v(" "),_c('span')],2)]):_c('div',{staticClass:"vb-complete-empty",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_vm._v("\n  Complete phrase\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1372);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("4ccb1254", content, true, {});

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-img-empty[data-v-06855854]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:2rem;border:.2rem dashed brown}.vb-img-empty.selected[data-v-06855854]{border:.2rem dashed red}.vb-img[data-v-06855854]{max-width:100%}.vb-img.selected[data-v-06855854]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookImage.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,YAAa,AACb,yBAA2B,CAC5B,AACD,wCACI,uBAAyB,CAC5B,AACD,yBACE,cAAgB,CACjB,AACD,kCACI,uBAAyB,CAC5B","file":"VirtualBookImage.vue","sourcesContent":["\n.vb-img-empty[data-v-06855854] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  height: 2rem;\n  border: .2rem dashed brown;\n}\n.vb-img-empty.selected[data-v-06855854] {\n    border: .2rem dashed red;\n}\n.vb-img[data-v-06855854] {\n  max-width: 100%;\n}\n.vb-img.selected[data-v-06855854] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.data.src)?_c('img',{staticClass:"vb-img",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"src":_vm.data.src,"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}}):_c('div',{staticClass:"vb-img-empty",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_c('strong',[_vm._v("IMG")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("a81364b4", content, true, {});

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-audio[data-v-5ef631ab]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%}.vb-audio.selected[data-v-5ef631ab]{border:.2rem dashed red}.vb-audio-player[data-v-5ef631ab]{background:#c9ec73;border:none;border-radius:25px;padding:5px 10px;width:150px}.vb-audio-player-btn[data-v-5ef631ab]{display:-webkit-box;display:-ms-flexbox;display:flex}.vb-audio-player-btn-img img[data-v-5ef631ab]{width:30px;height:30px}.vb-audio-player-btn-text[data-v-5ef631ab]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#5d9110}.vb-audio-player-btn-text[data-v-5ef631ab],.vb-audio-status[data-v-5ef631ab]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.vb-audio-status[data-v-5ef631ab]{position:relative;margin-left:10px;background:#c9ec73;border-radius:25px;border:none;padding:0 10px}.vb-audio-status-progress[data-v-5ef631ab]{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;z-index:10;background-color:#699401;height:5px;border-radius:25px}.vb-audio-status-progress-box[data-v-5ef631ab]{position:relative}.vb-audio-status-progress-box-dot[data-v-5ef631ab]{position:absolute;right:-5px;top:-2px;width:10px;height:10px;background:#699401;border-radius:10px}.vb-audio-status-bar[data-v-5ef631ab]{position:absolute;z-index:0;border-radius:25px;width:calc(100% - 20px);background:#e3ffba;height:5px}.vb-audio-description[data-v-5ef631ab]{width:280px;margin-left:10px;font-size:13px;border:1px solid #8ac326;border-radius:25px;padding:5px 5px 5px 25px;background:#e3ffba;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookAudio.vue"],"names":[],"mappings":"AACA,2BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,UAAY,CACb,AACD,oCACI,uBAAyB,CAC5B,AACD,kCACI,mBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,iBAAkB,AAClB,WAAa,CAChB,AACD,sCACM,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACnB,AACD,8CACQ,WAAY,AACZ,WAAa,CACpB,AACD,2CAIQ,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAOhC,aAAe,CACtB,AACD,6EAdQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAId,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAmB5B,AAhBD,kCACI,kBAAmB,AAUnB,iBAAkB,AAClB,mBAAoB,AACpB,mBAAoB,AACpB,YAAa,AACb,cAAgB,CACnB,AACD,2CACM,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,WAAY,AACZ,yBAA0B,AAC1B,WAAY,AACZ,kBAAoB,CACzB,AACD,+CACQ,iBAAmB,CAC1B,AACD,mDACU,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,kBAAoB,CAC7B,AACD,sCACM,kBAAmB,AACnB,UAAW,AACX,mBAAoB,AACpB,wBAAyB,AACzB,mBAAoB,AACpB,UAAY,CACjB,AACD,uCACI,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,yBAA0B,AAC1B,mBAAoB,AACpB,yBAA0B,AAC1B,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B","file":"VirtualBookAudio.vue","sourcesContent":["\n.vb-audio[data-v-5ef631ab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  width: 100%;\n}\n.vb-audio.selected[data-v-5ef631ab] {\n    border: .2rem dashed red;\n}\n.vb-audio-player[data-v-5ef631ab] {\n    background: #c9ec73;\n    border: none;\n    border-radius: 25px;\n    padding: 5px 10px;\n    width: 150px;\n}\n.vb-audio-player-btn[data-v-5ef631ab] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.vb-audio-player-btn-img img[data-v-5ef631ab] {\n        width: 30px;\n        height: 30px;\n}\n.vb-audio-player-btn-text[data-v-5ef631ab] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n        color: #5d9110;\n}\n.vb-audio-status[data-v-5ef631ab] {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    margin-left: 10px;\n    background: #c9ec73;\n    border-radius: 25px;\n    border: none;\n    padding: 0 10px;\n}\n.vb-audio-status-progress[data-v-5ef631ab] {\n      position: absolute;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      z-index: 10;\n      background-color: #699401;\n      height: 5px;\n      border-radius: 25px;\n}\n.vb-audio-status-progress-box[data-v-5ef631ab] {\n        position: relative;\n}\n.vb-audio-status-progress-box-dot[data-v-5ef631ab] {\n          position: absolute;\n          right: -5px;\n          top: -2px;\n          width: 10px;\n          height: 10px;\n          background: #699401;\n          border-radius: 10px;\n}\n.vb-audio-status-bar[data-v-5ef631ab] {\n      position: absolute;\n      z-index: 0;\n      border-radius: 25px;\n      width: calc(100% - 20px);\n      background: #e3ffba;\n      height: 5px;\n}\n.vb-audio-description[data-v-5ef631ab] {\n    width: 280px;\n    margin-left: 10px;\n    font-size: 13px;\n    border: 1px solid #8ac326;\n    border-radius: 25px;\n    padding: 5px 5px 5px 25px;\n    background: #e3ffba;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vb-audio",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_c('button',{staticClass:"vb-audio-player",attrs:{"type":"button","name":"button"},on:{"click":_vm.toogle}},[_c('div',{staticClass:"vb-audio-player-btn"},[_c('div',{staticClass:"vb-audio-player-btn-img"},[(!_vm.playing)?_c('font-awesome-icon',{attrs:{"icon":"play","color":"#4c6a00"}}):_c('font-awesome-icon',{attrs:{"icon":"pause","color":"#4c6a00"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('audio',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"vb-audio-player",attrs:{"src":_vm.data.src},on:{"loadeddata":_vm.setAudioData,"play":function($event){_vm.playing = true},"pause":function($event){_vm.playing = false},"timeupdate":function($event){_vm.currentTime = $event.target.currentTime}}})])]),_vm._v(" "),_c('div',{staticClass:"vb-audio-status"},[_c('div',{staticClass:"vb-audio-status-progress",style:({ width: ("calc(" + ((_vm.currentTime * 100) / _vm.duration) + "% - 20px)") })},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"vb-audio-status-bar"})]),_vm._v(" "),_c('div',{staticClass:"vb-audio-description"},[_vm._v("\n    Listening correspondente ao tópico.\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vb-audio-player-btn-text"},[_c('strong',[_vm._v("Play Listening")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vb-audio-status-progress-box"},[_c('div',{staticClass:"vb-audio-status-progress-box-dot"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookDiv_vue__ = __webpack_require__(1201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df92816_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookDiv_vue__ = __webpack_require__(1384);
function injectStyle (ssrContext) {
  __webpack_require__(1378)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5df92816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookDiv_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df92816_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookDiv_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1379);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("e8103bec", content, true, {});

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-div[data-v-5df92816]{display:grid;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;grid-template-columns:1fr 1fr}.vb-div.selected[data-v-5df92816]{border:.2rem dashed red}.vb-div [data-v-5df92816]:first-child{padding-right:5px}.vb-div [data-v-5df92816]:not(:first-child){padding-left:5px}.vb-div-empty[data-v-5df92816]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:.5rem;height:4rem;border:.2rem dashed brown}.vb-div-empty.selected[data-v-5df92816]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookDiv.vue"],"names":[],"mappings":"AACA,yBACE,aAAc,AACd,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,6BAA+B,CAChC,AACD,kCACI,uBAAyB,CAC5B,AACD,sCACI,iBAAmB,CACtB,AACD,4CACI,gBAAkB,CACrB,AACD,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,aAAc,AACd,YAAa,AACb,yBAA2B,CAC5B,AACD,wCACI,uBAAyB,CAC5B","file":"VirtualBookDiv.vue","sourcesContent":["\n.vb-div[data-v-5df92816] {\n  display: grid;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  grid-template-columns: 1fr 1fr;\n}\n.vb-div.selected[data-v-5df92816] {\n    border: .2rem dashed red;\n}\n.vb-div *[data-v-5df92816]:first-child {\n    padding-right: 5px;\n}\n.vb-div *[data-v-5df92816]:not(:first-child) {\n    padding-left: 5px;\n}\n.vb-div-empty[data-v-5df92816] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin: .5rem;\n  height: 4rem;\n  border: .2rem dashed brown;\n}\n.vb-div-empty.selected[data-v-5df92816] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookDivVertical_vue__ = __webpack_require__(1202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1b9b178_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookDivVertical_vue__ = __webpack_require__(1383);
function injectStyle (ssrContext) {
  __webpack_require__(1381)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1b9b178"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookDivVertical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1b9b178_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookDivVertical_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("709a257b", content, true, {});

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-div-vertical[data-v-f1b9b178]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.vb-div-vertical.selected[data-v-f1b9b178]{border:.2rem dashed red}.vb-div-vertical [data-v-f1b9b178]:not(:first-child){margin-top:10px}.vb-div-vertical-empty[data-v-f1b9b178]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:.5rem;height:4rem;border:.2rem dashed brown}.vb-div-vertical-empty.selected[data-v-f1b9b178]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookDivVertical.vue"],"names":[],"mappings":"AACA,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,2CACI,uBAAyB,CAC5B,AACD,qDACI,eAAiB,CACpB,AACD,wCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,aAAc,AACd,YAAa,AACb,yBAA2B,CAC5B,AACD,iDACI,uBAAyB,CAC5B","file":"VirtualBookDivVertical.vue","sourcesContent":["\n.vb-div-vertical[data-v-f1b9b178] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.vb-div-vertical.selected[data-v-f1b9b178] {\n    border: .2rem dashed red;\n}\n.vb-div-vertical *[data-v-f1b9b178]:not(:first-child) {\n    margin-top: 10px;\n}\n.vb-div-vertical-empty[data-v-f1b9b178] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin: .5rem;\n  height: 4rem;\n  border: .2rem dashed brown;\n}\n.vb-div-vertical-empty.selected[data-v-f1b9b178] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.components && !!_vm.components.length)?_c('div',{staticClass:"vb-div-vertical",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.selectedPath == _vm.path},on:{"scroll":function($event){return _vm.$emit('scroll', $event)},"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},_vm._l((_vm.components),function(component,key){return _c(("vb-" + (component.type)),{key:("div-vertical-" + key),tag:"component",attrs:{"data":component,"path":(_vm.path + "-" + key),"draggable":_vm.selectedPath == (_vm.path + "-" + key),"selectedPath":_vm.selectedPath},on:{"update":function($event){return _vm.$emit('update')},"select":function (p) { return _vm.$emit('select', p); },"toDrag":function (p) { return _vm.$emit('toDrag', p); },"toDrop":function (p) { return _vm.$emit('toDrop', p); },"answer":function (payload) { return _vm.$emit('answer', payload); }}})}),1):_c('div',{staticClass:"vb-div-vertical-empty",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.data && _vm.data.type != 'page' && _vm.selectedPath == _vm.path},on:{"scroll":function($event){return _vm.$emit('scroll', _vm.path)},"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_vm._v("\n  Div Vertical\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.components && !!_vm.components.length)?_c('div',{staticClass:"vb-div",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.selectedPath == _vm.path},on:{"scroll":function($event){return _vm.$emit('scroll', $event)},"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},_vm._l((_vm.components),function(component,key){return _c(("vb-" + (component.type)),{key:("div-" + key),tag:"component",attrs:{"data":component,"path":(_vm.path + "-" + key),"components":component.type != 'div-vertical' ? undefined : component.components,"draggable":_vm.selectedPath == (_vm.path + "-" + key),"selectedPath":_vm.selectedPath},on:{"update":function($event){return _vm.$emit('update')},"select":function (p) { return _vm.$emit('select', p); },"toDrag":function (p) { return _vm.$emit('toDrag', p); },"toDrop":function (p) { return _vm.$emit('toDrop', p); },"answer":function (payload) { return _vm.$emit('answer', payload); }}})}),1):_c('div',{staticClass:"vb-div-empty",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.data && _vm.data.type != 'page' && _vm.selectedPath == _vm.path},on:{"scroll":function($event){return _vm.$emit('scroll', _vm.path)},"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_vm._v("\n  Div\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookText_vue__ = __webpack_require__(1203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61918ad4_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookText_vue__ = __webpack_require__(1388);
function injectStyle (ssrContext) {
  __webpack_require__(1386)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61918ad4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VirtualBookText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61918ad4_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VirtualBookText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1387);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("00cea53b", content, true, {});

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".vb-text[data-v-61918ad4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-weight:500;font-size:13px;color:#fff}.vb-text-content[data-v-61918ad4]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:5px 30px;border-radius:100px;max-width:100%}.vb-text-content p[data-v-61918ad4]{word-break:break-word;margin:0}.vb-text.selected[data-v-61918ad4]{border:.2rem dashed red}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/VirtualBookViewer/VirtualBookText.vue"],"names":[],"mappings":"AACA,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,kCACI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,iBAAkB,AAClB,oBAAqB,AACrB,cAAgB,CACnB,AACD,oCACM,sBAAuB,AACvB,QAAU,CACf,AACD,mCACI,uBAAyB,CAC5B","file":"VirtualBookText.vue","sourcesContent":["\n.vb-text[data-v-61918ad4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-weight: 500;\n  font-size: 13px;\n  color: #FFF;\n}\n.vb-text-content[data-v-61918ad4] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    padding: 5px 30px;\n    border-radius: 100px;\n    max-width: 100%;\n}\n.vb-text-content p[data-v-61918ad4] {\n      word-break: break-word;\n      margin: 0;\n}\n.vb-text.selected[data-v-61918ad4] {\n    border: .2rem dashed red;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vb-text",class:{ selected: _vm.selectedPath == _vm.path },attrs:{"draggable":_vm.draggable},on:{"load":function (ev) { return _vm.$emit('update'); },"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.path)},"dragstart":function($event){$event.stopPropagation();return _vm.$emit('toDrag', _vm.path)},"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.$emit('toDrop', _vm.path)}}},[_c('div',{staticClass:"vb-text-content",style:({
      backgroundColor: _vm.data.color || '#CCC'
    })},[_c('p',[_vm._v(_vm._s(_vm.data.text || ' '))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vb-container",attrs:{"draggable":_vm.data && _vm.data.type != 'page' && _vm.selectedPath == _vm.path},on:{"scroll":function($event){return _vm.$emit('scroll', $event)},"click":function($event){return _vm.$emit('select', _vm.path)}}},_vm._l((_vm.components),function(component,key){return _c(("vb-" + (component.type)),{key:("component-" + key),tag:"component",attrs:{"data":component,"path":(_vm.path + "-" + key),"components":component.type != 'div' ? undefined : (component.components || []),"draggable":_vm.selectedPath == (_vm.path + "-" + key),"selectedPath":_vm.selectedPath},on:{"update":function($event){return _vm.$emit('update')},"select":function (p) { return _vm.$emit('select', p); },"toDrag":function (p) { return _vm.$emit('toDrag', p); },"toDrop":function (p) { return _vm.$emit('toDrop', p); },"answer":function (payload) { return _vm.$emit('answer', payload); }}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vb-viewer"},[_c('vb-container',{ref:"page",staticClass:"vb-page",attrs:{"components":_vm.currentPage.components,"data":_vm.currentPage,"path":("" + _vm.pageIndex),"edit":_vm.edit,"selectedPath":_vm.selectedPath},on:{"scroll":_vm.scroll,"update":_vm.setHeightPage,"select":function (path) { return _vm.$emit('select', path); },"toDrag":function (path) { return _vm.$emit('drag', path); },"toDrop":function (path) { return _vm.$emit('drop', path); },"answer":function (payload) { return _vm.$emit('answer', payload); }}}),_vm._v(" "),_c('div',{staticClass:"vb-control animation-right"},[_c('div',{staticClass:"vb-control-div vb-controll-div--hide"},[_c('button',{staticClass:"vb-control-btn",attrs:{"disabled":_vm.currentHeight == _vm.minHeight},on:{"click":_vm.scrollUp}},[_c('div',{staticClass:"vb-control-btn-icon"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-up"}})],1),_vm._v(" "),_c('div',{staticClass:"vb-control-btn-text"},[_vm._v("\n          RIDE UP\n        ")])]),_vm._v(" "),_c('button',{staticClass:"vb-control-btn",attrs:{"disabled":_vm.currentHeight == _vm.maxHeight},on:{"click":_vm.scrollDown}},[_c('div',{staticClass:"vb-control-btn-icon"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-down"}})],1),_vm._v(" "),_c('div',{staticClass:"vb-control-btn-text"},[_vm._v("\n          RIDE DOWN\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"vb-control-div"},[_c('div',{staticClass:"vb-control-page"},[_c('button',{staticClass:"vb-control-page-btn",attrs:{"disabled":_vm.pageNumber !== _vm.currentPage.page},on:{"click":function($event){return _vm.goToPage()}}},[_c('font-awesome-icon',{attrs:{"width":"28","icon":"search"}})],1),_vm._v(" "),_c('input',{ref:"page_number",staticClass:"vb-control-page-input",attrs:{"type":"number","min":_vm.minPage,"max":_vm.maxPage,"value":"0"}})])]),_vm._v(" "),_c('div',{staticClass:"vb-control-div"},[_c('button',{staticClass:"vb-control-btn",attrs:{"disabled":_vm.pageIndex == (_vm.pages.length - 1)},on:{"click":_vm.nextPage}},[_c('div',{staticClass:"vb-control-btn-icon"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-right"}})],1),_vm._v(" "),_c('div',{staticClass:"vb-control-btn-text"},[_vm._v("\n          NEXT PAGE\n        ")])]),_vm._v(" "),_c('button',{staticClass:"vb-control-btn",attrs:{"disabled":_vm.pageIndex == 0},on:{"click":_vm.prevPage}},[_c('div',{staticClass:"vb-control-btn-icon"},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}})],1),_vm._v(" "),_c('div',{staticClass:"vb-control-btn-text"},[_vm._v("\n          PREVIOUS PAGE\n        ")])])]),_vm._v(" "),_c('button',{staticClass:"vb-control-btn vb-control-btn-back",on:{"click":function () { return !_vm.goBack ? undefined : _vm.goBack(); }}},[_vm._v("\n      BACK\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"box-content--header container align-items-center justify-content-center hidden"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-content--header__text flex-grow-1 flex-basis-400"},[_c('div',{staticClass:"container align-items-center mobileWrap"},[_c('h2',{staticClass:"animation-top animation-delay-02"},[_c('strong',[_vm._v(" "+_vm._s((_vm.book.title || '').toUpperCase()))])]),_vm._v(" "),_c('div',{staticClass:"margin-left-10 margin-right-10 container aling-items-end animation-top animation-delay-04 mobileAdjust"},[_c('button',{staticClass:"btn btn-sm btn-rounded gradient-yellow btn-padding mobileAdjust",staticStyle:{"color":"rgb(196, 0, 60)"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Voltar")])])])])]),_vm._v(" "),_c('div',{staticClass:"shadow-box box-content-border margin-bottom-10 width-full"},[_c('VBViewer',{ref:"vb-viewer",attrs:{"pages":_vm.pages || [],"goBack":function () { return _vm.$router.go(-1); }},on:{"answer":_vm.answerQuestion}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content--header__img"},[_c('div',{staticClass:"img1 container align-items-center justify-content-center animation-top"},[_c('div',{staticClass:"img2 container align-items-center justify-content-center"},[_c('img',{attrs:{"src":__webpack_require__(193),"width":"50","alt":"Minds"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_vue__ = __webpack_require__(1192);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd84426_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_book_vue__ = __webpack_require__(1391);
function injectStyle (ssrContext) {
  __webpack_require__(1354)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_book_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd84426_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_book_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(713);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(772);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(714), __esModule: true };

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53);
__webpack_require__(715);
module.exports = __webpack_require__(9).Array.from;


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(54);
var $export = __webpack_require__(29);
var toObject = __webpack_require__(56);
var call = __webpack_require__(196);
var isArrayIter = __webpack_require__(197);
var toLength = __webpack_require__(125);
var createProperty = __webpack_require__(716);
var getIterFn = __webpack_require__(126);

$export($export.S + $export.F * !__webpack_require__(198)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(32);
var createDesc = __webpack_require__(55);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(773), __esModule: true };

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(774);
var $Object = __webpack_require__(9).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ })

});


// WEBPACK FOOTER //
// static/js/9.85b758161fbb0451c0cf.js